module.exports = __webpack_public_path__ + "img/btn-marquee-active.878d14b5.svg";